var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #757575;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.5,33l-2.5-2.5-1,3.5-1.5,1-2.5,3,1.5,2.5,2,.5,2,1v6.5l-1.5,2.5-1.5,2.5h-3l-.5,1.5,1,1.5,3,.5,4-2.5,5-5.5,2.5-.5,2.5,5-1,1.5,.5,1.5,2,.5,2-.5,.5-3.5-1.5-3,1-2,6-.5v2.5l2,1v2l-2.5,2v2l3.5,.5,3.5-3.5,1-2-1.5-3.5,4,2,1.5,4.5,1.5,1,1.5-.5,.5-4.5-1.5-3-3-5-1-5,2.5-2,1-3,1-3-.5-4-3.5-3-2.5-.5h-2.5l-2.5,2.5,1,3,3.5-1.5,1,.5,1,1v2l-2,4.5-2,.5h-11l-6.5,2-3-1.5c-.8-.4-2.67-1.83-3.5-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/cat.5e46073656560fcaad3bc7d9322f56b8.svg";
export { ForwardRef as ReactComponent };